import { render, staticRenderFns } from "./General.vue?vue&type=template&id=67c037fa&scoped=true&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"
import style0 from "./General.vue?vue&type=style&index=0&id=67c037fa&prod&lang=css&"
import style1 from "./General.vue?vue&type=style&index=1&id=67c037fa&prod&scoped=true&lang=scss&"
import style2 from "./General.vue?vue&type=style&index=2&id=67c037fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c037fa",
  null
  
)

export default component.exports